import { render, staticRenderFns } from "./main_prematch.vue?vue&type=template&id=37b3a6ae&scoped=true"
import script from "./main_prematch.vue?vue&type=script&lang=js"
export * from "./main_prematch.vue?vue&type=script&lang=js"
import style0 from "./main_prematch.vue?vue&type=style&index=0&id=37b3a6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3a6ae",
  null
  
)

export default component.exports